import { render, staticRenderFns } from "./sponsored.vue?vue&type=template&id=0dfe9f38"
import script from "./sponsored.vue?vue&type=script&lang=js"
export * from "./sponsored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports